import React, { ReactNode } from 'react'

interface IProps {
  children: ReactNode
  alignResults: 'justify' | 'center'
}

const ResultContainer = ({ children, alignResults }: IProps) => (
  <div
    className={'cs-md-4of12 csas-results-section csas-results-section--' + alignResults}
    style={{ padding: '0' }}
    data-testid='result-container'
  >
    {children}
  </div>
)

export default ResultContainer
